import GeneratedLibHistoryServiceApi from "./generated/GeneratedLibHistoryServiceApi"

class LibHistoryServiceApi extends GeneratedLibHistoryServiceApi {

}

export const libHistoryServiceApi = new LibHistoryServiceApi()
